import { Environment } from "./environment.models";

export const environment: Environment = {
  production: true,
  backendUrl: 'https://www.backcourt-software.de/api/api'
};
